import {Box, Link, Typography} from "@mui/material";
import flare from "../assets/flare/rip-footer.svg";
import facebook from "../assets/social/facebook.svg";
import instagram from "../assets/social/instagram.svg";
import redappleprivate from '../assets/social/redapple.png'

function Footer() {
    return (
        <>
            <Box sx={{backgroundColor: '#f0e3d7',}}>
                <img style={{
                    width: '100vw',
                    objectFit: 'cover',
                    maxHeight: 125,
                    objectPosition: 'top',
                }} src={flare} alt={"ripped paper"}/>
            </Box>
            <Box sx={{
                backgroundColor: '#3A1F0C', minHeight: 200, color: 'white', pb: 1,
            }}>
                <Box className={'footer'} sx={{display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around', }}>
                    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: {xs: 'center', sm: 'start'}, mt: 5, width: 200,}}>
                        <Link sx={{fontWeight: 'bold'}}>Our Story</Link>
                        <Link href={"/#our-approach"}>Our Approach</Link>
                        <Link href={"/#learning-environment"}>Learning Environment</Link>
                        <Link href={"/#family-engagement"}>Family Engagement</Link>
                        {/*<Link>Accreditation</Link>*/}
                    </Box>
                    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: {xs: 'center', sm: 'start'}, mt: 5, width: 200,}}>
                        <Link sx={{fontWeight: 'bold'}}>Academics</Link>
                        <Link href={"/academics/#curriculum"}>Curriculum</Link>
                        <Link href={"/academics/#nido"}>Nido</Link>
                        <Link href={"/academics/#preschool"}>Preschool</Link>
                        <Link href={"/academics/#primary"}>Primary</Link>
                        <Link href={"/academics/#scaffolded-groups"}>Scaffolded Groups</Link>
                    </Box>
                    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: {xs: 'center', sm: 'start'}, mt: 5, width: 200,}}>
                        <Link sx={{fontWeight: 'bold'}}>Arts & Labs</Link>
                        <Link href={"/arts-labs/#art-lab"}>Art Lab</Link>
                        <Link href={"/arts-labs/#culinary-lab"}>Culinary Lab</Link>
                        <Link href={"/arts-labs/#language-immersion"}>Language Immersion</Link>
                        <Link href={"/arts-labs/#mindfulness"}>Mindfulness</Link>
                    </Box>
                    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: {xs: 'center', sm: 'start'}, mt: 5, width: 200,}}>
                        <Link href={"/admissions"}>Admissions</Link>
                        <Link href={"/our-schools"}>Our Schools</Link>
                        <Link href={"/lets-talk"}>Let's Talk</Link>
                        <Link href={"/careers"}>Careers</Link>
                        <Link href={"https://www.goodheartsgear.com/collections/prodigy-early-learning"}>Uniforms</Link>
                    </Box>
                </Box>
                <Box sx={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center'}}>
                    <Box sx={{display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around', mt:4,}}>
                        {/*<Box component={"img"} sx={{width:300,}} src={logo}/>*/}
                        <Box>
                            <Typography variant="h5" sx={{fontWeight:'bold', mb:1,}}>Stay Connected</Typography>
                            <Box sx={{display:'flex', flexDirection:'row', justifyContent:'center',}}>
                                <Link href={"https://facebook.com/prodigylearn"}><Box component={"img"} src={facebook} sx={{width:30,}}></Box></Link>
                                <Box sx={{width:30,}}/>
                                <Link href={"https://instagram.com/prodigyearlylearnusa"}><Box component={"img"} src={instagram} sx={{width:30,}}></Box></Link>
                            </Box>

                        </Box>
                    </Box>

                    <Link sx={{mt:5, mb:8}} href={"#"}><Box component={"img"} src={redappleprivate} sx={{width: 100}}></Box></Link>

                    <Box sx={{mt: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1}}>
                        <Typography
                            variant={"caption"}>© {(new Date()).getFullYear()} Prodigy Learn</Typography>
                        <Box sx={{display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center'}}>
                            <Link href="/privacy-policy" sx={{color: 'white', fontSize: '0.75rem'}}>
                                Privacy Policy
                            </Link>
                            <Typography variant={"caption"} sx={{color: 'white'}}>|</Typography>
                            <Link href="/terms-of-service" sx={{color: 'white', fontSize: '0.75rem'}}>
                                Terms of Service
                            </Link>
                        </Box>
                    </Box>

                </Box>



            </Box>
        </>
    );
}

export default Footer
